import { SvgIcon, SvgIconProps } from '@mui/material';

export const ImagePlaceholder = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 48 48" {...props}>
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="m6 36 9.8-9.8c.8-.8 1.1-1.1 1.6-1.3a2 2 0 0 1 1.2 0c.5.1.9.5 1.7 1.3l8.7 8.5m14 .7-5.1-5.1a5.7 5.7 0 0 0-1.7-1.4 2 2 0 0 0-1.2 0c-.4.2-.8.6-1.6 1.4L29 34.7m8 8-8-8M36 16a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM13.6 44h20.8c3.4 0 5 0 6.3-.7a6 6 0 0 0 2.6-2.6c.7-1.3.7-3 .7-6.3V13.6c0-3.4 0-5-.7-6.3a6 6 0 0 0-2.6-2.6c-1.3-.7-3-.7-6.3-.7H13.6c-3.4 0-5 0-6.3.7a6 6 0 0 0-2.6 2.6c-.7 1.3-.7 3-.7 6.3v20.8c0 3.4 0 5 .7 6.3a6 6 0 0 0 2.6 2.6c1.3.7 3 .7 6.3.7Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      fill="none"
    />
  </SvgIcon>
);
